module.exports = __webpack_public_path__ + "img/MOET-01.17a32246.png";